// Le vocabulaire partagé des signaux, français. Il vit ICI et non dans le catalogue de la page,
// parce que SignalsZone est aussi sur les pages Personne et Organisation.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Signals': 'Signaux',
  'every signal cites what it was read from': 'chaque signal cite ce dont il a été tiré',
  'loading…': 'chargement…',
  'The signals could not be read: {error}': 'Les signaux n’ont pas pu être lus : {error}',
  'No monitor has raised anything for this subject. A signal is an observation with the snapshot, the publication or the snippet that proves it, and a suggested action. It never writes to the record: it proposes, and an operator holds or refuses it in Review.':
    'Aucune veille n’a rien signalé pour ce sujet. Un signal est une observation accompagnée de l’instantané, de la publication ou de l’extrait qui la prouve, et d’une action suggérée. Il n’écrit jamais au dossier : il propose, et l’opérateur le retient ou le refuse dans la Revue.',
  'Create task': 'Créer une tâche',
  'Dismiss': 'Écarter',
  'Task {ref} created': 'Tâche {ref} créée',
  '{ref} dismissed': '{ref} écarté',
  'Could not dispose of the signal.': 'Impossible de statuer sur le signal.',

  // genres de signal
  'risk': 'risque',
  'budget': 'budget',
  'board': 'conseil',
  'move': 'mouvement',
  'post': 'publication',
  'tender': 'appel d’offres',
  'mention': 'mention',
  'coverage': 'couverture',

  // décisions
  'task': 'tâche',
  'draft': 'brouillon',
  'dismissed': 'écarté',

  // ce dont le signal a été tiré
  'snapshot': 'capture',
  'publication': 'publication',
  'search': 'recherche',
  'surfe': 'Surfe',
  'manual': 'manuel',
  'computed': 'calculé',

  // genres de veille
  'website': 'site',
  'careers': 'emplois',
  'news': 'presse',
  'shab': 'FOSC',
  'zefix': 'Zefix',
  'surfe_job': 'Surfe · poste',
  'linkedin_manual': 'LinkedIn (manuel)',

  // issues d’une veille (« refused » vient du vocabulaire partagé)
  'unchanged': 'inchangé',
  'changed': 'modifié',
  'signal': 'signal',
  'error': 'erreur',

  // pourquoi un refus est un refus
  'robots': 'robots.txt',
  'blocked_host': 'hôte bloqué',
  'no_credentials': 'aucun identifiant',
  'manual_only': 'manuel uniquement',
  'no_linkedin_url': 'aucune URL LinkedIn',
}, 'SignalsZone');
